import { NonNullableSettingConfig } from "./NonNullableSettingConfig";
import { _throw, IllegalStateError } from "shared-ts-utils-core";
import { Interval } from "luxon";

export const IntervalSetting: NonNullableSettingConfig<Interval<true>> = {
  type: "interval",
  serialize: (value: Interval<true>): string => {
    return (
      value.toISO() ??
      _throw(new IllegalStateError("Invalid Interval: " + value))
    );
  },

  deserialize: (value: string): Interval<true> => {
    return (Interval.fromISO(value) ??
      _throw(
        new IllegalStateError("Invalid Interval: " + value)
      )) as Interval<true>;
  },
};
